import { PreclassCheckResultType } from "../shared/types/preclass-check";

import {
  ActivityCategory,
  ClassSessionSummaryType,
  ClassSessionType,
  PageCategory,
  UserType,
} from "components/server-types";
import { NestedOutcomeGroupType } from "store/selectors";

// TODO: This is a type file for all server-related data types
// that are outside the storeAPI.
// A future PR will move `server-types.ts` into this folder too.

// Engagement data

export enum EngagementLevel {
  NONE = "none",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export type UserEngagementDataType = {
  effort_level: EngagementLevel;
  effort_percentile?: number;
  performance_level: EngagementLevel;
  performance_average?: number;
  risk_level: EngagementLevel;
  attendance_count?: number;
  avg_talk_time_minutes?: number;
};

export type ExtendedUserEngagementDataType = UserType & UserEngagementDataType;

export type AssessmentStatusInfoType = {
  status: AssessmentStatus;
  unassessed_late_count: number;
  assessed_submissions_count: number;
};

export enum AssessmentStatus {
  NOT_ASSESSABLE = "not_assessable",
  ASSESSABLE = "assessable",
  ASSESSED = "assessed",
}

export enum InviteStatus {
  ACCEPTED = "accepted",
  NOT_SENT = "not_sent",
  PENDING = "pending",
  EXPIRED = "expired",
}

export type PageAssessmentStatusType = Record<string, AssessmentStatusInfoType>;
export type UserInviteStatusType = Record<string, InviteStatus>;

export type SectionAssessmentSummaryParams = {
  course_id?: string;
  term_id: string;
  start_date: string; // YYYY-MM-DD format
  end_date: string; // YYYY-MM-DD format
};

export type ProgressOverviewData = {
  averageOutcomeScore: number;
  outcomeGroups: NestedOutcomeGroupType[];
  totalOutcomesAssessed: number;
};

export interface ImportExternalSectionResponseType {
  title: string;
  description: string;
  course: {
    code: string;
  };
  term: {
    title: string;
  };
}

export interface ExtendedClassSessionSummaryType extends ClassSessionSummaryType, ClassSessionType {
  started_at: string;
  students: string[];
  attending_students: string[];
  attendance_percentage: number;
  instructor_talk_time_seconds: number;
  student_talk_time_seconds: number;
  student_presence_minutes?: number | null;
}

export interface AssessmentDataForPageType {
  id: string;
  title: string;
  topic_title: string | null;
  category: PageCategory;
  activity_category: ActivityCategory | null;
  outcomes_count: number;
  max_points: number;
}

export type InstructorAssessmentDataForPageType = AssessmentDataForPageType & {
  assessing_marked_complete_at: string | null;
  last_submitted_at: string | null;
  assessments_published_at: string | null;
  assessable_submissions_count: number;
  assessed_submissions_count: number;
  avg_points: number | null;
};

export type StudentAssessmentDataForPageType = AssessmentDataForPageType & {
  submitted_at: string;
  points: number | null;
  comment: string | null;
};

export interface AssessmentDataForSectionType {
  id: string;
  title: string;
  code_title: string;
  term_id: string;
  pages: AssessmentDataForPageType[];
}

export type InstructorAssessmentDataForSectionType = AssessmentDataForSectionType & {
  pages: InstructorAssessmentDataForPageType[];
};

export type StudentAssessmentDataForSectionType = AssessmentDataForSectionType & {
  pages: StudentAssessmentDataForPageType[];
};

export type SystemCheckResultsData = {
  user_full_name: string;
  user_email: string;
  user_created_at: string;
  ip: string;
  check_end_result: "passed" | "failed" | "na";
  test_results: PreclassCheckResultType;
  created_at: string;
  browser: string | null;
  os: string | null;
};
